const default_code_time = 15;
const default_cs_time = 5;

class Process {
  constructor(id, name, hasToken, codeTime, csTime) {
    this.id = id;
    this.name = name;
    this.hasToken = hasToken;
    this.isUsingToken = false;
    this.isRunningCS = 0;
    this.isWaitingToken = false;
    this.isReceivingToken = false;
	this.isRunningCode = codeTime;
   	this.codeTime = codeTime;
    this.csTime = csTime;
  }

  getState() {
    let state = {};
    if (this.isRunningCS === 0 || this.isRunningCS) {
      state.text = "Running Critical Section";
      state.time = this.isRunningCS;
    } else if (this.isWaitingToken) {
      state.text = "Waiting for CS Token";
    } else if (this.isRunningCode) {
      state.text = "Running Non-CS Code";
      state.time = this.isRunningCode;
    }
    return state;
  }

  getViewObject() {
    return {
      id: this.id,
      name: this.name,
      hasToken: this.hasToken,
      isReceivingToken: this.isReceivingToken,
      ...this.getState(),
    };
  }

  getStateString() {
    const name = this.name;
    const hasToken = this.hasToken ? "\tToken\t" : "\t\t";
    let state = "";
    if (
      this.isUsingToken &&
      typeof this.isRunningCS === "number" &&
      this.isRunningCS > 0
    ) {
      state = "Running Critical Section " + this.isRunningCS;
    } else if (this.isWaitingToken) {
      state = "Waiting for Token";
    } else if (this.isRunningCode !== false) {
      state = "Running Non-CS Code " + this.isRunningCode;
    } else {
      state = "Undefined";
    }
    return name + hasToken + state;
  }

  setRunningCode() {
    this.isRunningCode = this.codeTime;
    this.isWaitingToken = false;
    this.isRunningCS = false;
    this.isUsingToken = false;
  }

  setWaitingToken() {
    this.isWaitingToken = true;
    this.isRunningCS = false;
    this.isRunningCode = false;
    this.isUsingToken = false;
  }

  setRunningCS() {
    this.isUsingToken = true;
    this.isWaitingToken = false;
    this.isRunningCS = this.csTime;
    this.isRunningCode = false;
  }

  step() {
    if (this.isRunningCode > 0) {
      this.isRunningCode--;
    }
    if (this.isRunningCode === 0 && !this.isWaitingToken && !this.isRunningCS) {
      this.setWaitingToken();
    }
    if (
      this.isWaitingToken === true &&
      this.hasToken &&
      this.isRunningCS === false
    ) {
      this.setRunningCS();
    } else if (this.isRunningCS > 0) {
      this.isRunningCS--;
    }
    if (this.isRunningCS === 0) {
      this.setRunningCode();
    }
  }
}

class Simulation {
  constructor(numberOfProcesses, codeTime, csTime) {
	this.codeTime = codeTime;
    this.csTime = csTime;
	  
    this.processes = [...Array(numberOfProcesses).keys()].map(
      (i) =>
        new Process(
          1 + i,
          "Process ".concat((1 + i).toString()),
          i === 0,
          Math.floor(Math.random() * codeTime)+1,
          Math.floor(Math.random() * csTime)+1
        )
    );
    this.processes.map((p) => p.setRunningCode());
    this.currentStart = 0;
  }

  tryPassToken(idx) {
    const fromProc = this.processes[idx];
    const toProc = this.processes[(idx + 1) % this.processes.length];

    if (fromProc.hasToken && !fromProc.isUsingToken) {
      fromProc.hasToken = false;
      toProc.isReceivingToken = true;
      this.currentStart = (this.currentStart + 1) % this.processes.length;
    }

    if (fromProc.isReceivingToken) {
      fromProc.isReceivingToken = false;
      fromProc.hasToken = true;
    }
  }

  step() {
    this.tryPassToken(this.currentStart);
    for (let i = 0; i < this.processes.length; i++) {
      const idx = (i + this.currentStart) % this.processes.length;
      const p = this.processes[idx];

      p.step();

      if (
        //(i + this.currentStart) % this.processes.length === 0 &&
        p.hasToken &&
        !p.isUsingToken &&
        p.isRunningCode < this.codeTime
      ) {
      }
    }
  }
}

export { Simulation, Process };
